const NAMESPACE = 'reporting';

export const selectPageLoadId = (state) => state?.[NAMESPACE]?.pageLoadId || '';
export const selectBreadcrumbId = (state) => state?.[NAMESPACE]?.breadcrumbId || '';
